export default __webpack_public_path__ + "images/models/9df65534e9bb6f46a728d94e9478171d.usdz";